import React from "react";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import DeleteCourse from "../DeleteCourse/DeleteCourse";

const DeleteCourseModal = ({ visible, onClose, onDeleteCourse }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Delete Course">
      <DeleteCourse deleteButtonClick={onDeleteCourse} backButtonClick={onClose} />
    </CustomModal>
  );
};

export default DeleteCourseModal;
